export default __webpack_public_path__ + "media/images/elephant_ui_plane-72f8702db120a51a1cdbc4fb7f5ef59d.svg";